import { Controller, RegisterOptions, useFormContext } from 'react-hook-form';
import { InputProps } from 'semantic-ui-react';

import { DateTimePickerInput } from 'pkg/components/DateTimePickerInput';

import { FormValidationMessage } from './FormValidationMessage';

interface DateTimePickerWithValidationProps extends Omit<InputProps, 'children' | 'value'> {
  inputIcon: JSX.Element;
  rules?: RegisterOptions;
}

export const DateTimePickerWithValidation = ({
  inputIcon,
  name,
  rules,
  ...inputProps
}: DateTimePickerWithValidationProps): JSX.Element => {
  const { errors } = useFormContext();
  const error = errors[name];

  return (
    <>
      <Controller
        name={name}
        rules={rules}
        render={(props) => (
          <DateTimePickerInput
            {...inputProps}
            error={Boolean(error)}
            inputIcon={inputIcon}
            date={props.value}
            setDate={props.onChange}
          />
        )}
      />
      <FormValidationMessage>{error?.message}</FormValidationMessage>
    </>
  );
};
